import { render } from "./ServicePaymentStatus.vue?vue&type=template&id=85a9d0c6&ts=true"
import script from "./ServicePaymentStatus.vue?vue&type=script&lang=ts"
export * from "./ServicePaymentStatus.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__